import CustomButton from "./Button"

const PrimaryButton = ({ isVerified, style, ...props }) => {
    return (
        <CustomButton
            {...props}
            type="primary"
            style={{
                padding: "24px 32px",
                border: "none",
                backgroundColor: isVerified ? "#00874F" : undefined,
                color: "#fff",
                borderRadius: 5,
                ...style,
            }}
        >
            {props.children}
        </CustomButton>
    )
}

export default PrimaryButton